export default "__VITE_ASSET__CmXREgxf__"